import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
// import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import {
  addAsset,
  addSurvey,
  addTask,
  addTaskSubmittal,
  deleteProjectAssetTasks,
  fetchMviewRegion,
  getAllRegionCompanies,
  getAllSubmittals,
  getAssetFilters,
  getDisciplines,
  getProjectAssetTasks,
  getSiteLocations,
} from "../../helpers/axios/projectsAxios";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { ButtonGroup } from "react-bootstrap";
import {
  ALL_ASSETS,
  ALL_DOCS,
  ALL_PROJECT_SUBMITTALS,
  SHOW_TOAST,
  TOAST_BODY,
  TOAST_TITLE,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";
import {
  agGridOptionsMultiple,
  agGridTheme,
  MandatoryExplanation,
  MandatoryFieldIndicator,
  submittalFileTypes,
} from "../../helpers/constants/Constants";
import {
  getAllRegionAssets,
  getMWHAssets,
} from "../../helpers/axios/assetsAxios";
import LoadingScreen from "../loadingScreen/LoadingScreen";
// import Comments from "../comments/Comments";

const ProjectConfig = () => {
  const {
    selectedProject,
    userDetails,
    allDocs,
    allProjectUsers,
    allSurveys,
    allAssets,
    regionalStatuses,
  } = useSelector((state) => state.globalReducer);
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingModels, setIsSavingModels] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [, setIncludeDefaultModels] = useState(false);
  // const [allAssets, setAssets] = useState(null);
  const [locations, setLocations] = useState(null);
  const [disciplines, setDisciplines] = useState(null);
  const [mwhAssets, setMWHAssets] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [gridApi, setGridApi] = useState();
  const [modal, setModal] = useState(false);
  const [assetModal, setAssetModal] = useState(false);
  const [surveyModal, setSurveyModal] = useState(false);
  const [submittalModal, setSubmittalModal] = useState(false);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [mviewDocNumbers, setMviewDocNumbers] = useState();
  const [newModelData, setNewModelData] = useState();
  const [surveyModelData, setSurveyModelData] = useState();
  const [submittalData, setSubmittalData] = useState();

  const [assetFilters, setAssetFilters] = useState([]);
  const [assetFilterLevels, setAssetFilterLevels] = useState([]);

  const [regionalTopLevels, setRegionalTopLevels] = useState([]);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [projectConfigLoading, setProjectConfigLoading] = useState(true);
  const [regionData, setRegionData] = useState();
  const [surveyProgress, setSurveyProgress] = useState(0);
  const [totalTasks, setTotalTasks] = useState(0);
  const [gridPageSizeMode, setGridPageSizeMode] = useState("auto");
  // let completedCount = 0;
  // let totalTasks = 0;

  // const [selectedAsset, setSelectedAsset] = useState({
  //   value: null,
  //   label: "Please select an asset to add",
  // });

  const dispatch = useDispatch();

  useEffect(() => {
    fetchSiteLocations();
    fetchDisciplines();
    fetchMWHAssets();
    if (selectedProject[0]?.mviewProjectInfo?.region?.assetFilterReq)
      fetchRegionAssetFilters(selectedProject[0]?.mviewProjectInfo?.regionCode);
  }, [selectedProject]);

  useEffect(() => {
    if (selectedProject) {
      getProjectAssetData();
      // fetchAssetData();
      // setSelectedAsset({
      //   value: null,
      //   label: "Please select an asset to add",
      // });
      setSelectedFiles([]);
      fetchCompanies();
      fetchRegionData();
    }
  }, [selectedProject]);

  const fetchCompanies = async () => {
    const companies = await getAllRegionCompanies(
      selectedProject[0].mviewProjectInfo.regionCode,
    );
    const sortedData = companies?.sort((a, b) => a.name.localeCompare(b.name));
    setCompanyOptions(sortedData);
  };

  const fetchRegionData = async () => {
    const regionCode = selectedProject[0].mviewProjectInfo.regionCode;
    const tempRegionData = await fetchMviewRegion(regionCode);

    const levels = [
      ...new Set(
        tempRegionData.data.assetExtraData
          .sort((a, b) => a.levelIndex - b.levelIndex)
          .map((filter) => filter.level),
      ),
    ];
    setRegionalTopLevels(levels);
    setRegionData(tempRegionData.data);
  };

  //  const fetchRegionAssetFilters = async (regionCode, id, levelIndex) => {
  //     const assetFiltersTemp = await getAssetFilters(regionCode, id);
  //     const newAssetFilters = [
  //       ...assetFilters.filter((o) => o.levelIndex <= levelIndex),
  //       ...assetFiltersTemp?.data,
  //     ];
  //     const levels = [
  //       ...new Set(
  //         newAssetFilters
  //           .sort((a, b) => a.levelIndex - b.levelIndex)
  //           .map((filter) => filter.level)
  //       ),
  //     ];
  //     //Set the asset filter levels to be all the unique levels from the asset filters
  //     setAssetFilterLevels(levels);
  //     setAssetFilters(newAssetFilters);
  //   };

  // const fetchAssetData = async () => {
  //   const tempAssets = await getAllRegionAssets(
  //     selectedProject[0].mviewProjectInfo.regionCode,
  //     selectedProject[0].mviewProjectInfo.siteType
  //   );

  //   const sortedData = tempAssets.sort((a, b) =>
  //     a.asset.name.localeCompare(b.asset.name)
  //   );
  //   setAssets(sortedData);
  // };

  // const removeDuplicates = (arr) => {
  //   return arr.filter((item, index) => arr.indexOf(item) === index);
  // };

  const fetchProjectAssetData = async (project) => {
    setProjectConfigLoading(true);
    try {
      var temp = await getProjectAssetTasks(project[0].id);
      if (temp.length > 0) {
        setRowData(
          temp.map((data) => {
            //filter submittal to remove any that are Approved then get the status of the latest submittal
            const latestSubmittal = data.submittals.filter(
              (submittal) => submittal.status !== "Approved",
            );
            return {
              id: data.id,
              asset: data.projectAsset.asset.name,
              model: data.task,
              discipline: data.discipline,
              documentNumber: data.docNumber,
              company: "",
              history: data.versions.length === 0 ? false : true,
              retired: data.status === "Retired" ? true : false,
              liveSubmittal: latestSubmittal.length === 0 ? false : true,
              mwhAssetName: data.mwhAssetName,
              status: data.status,
              lastUpdated: data.lastUpdated,
              publishedRevision: data.publishedRevision,
              sharedRevision: data.sharedRevision,
            };
          }),
        );
      } else {
        setRowData([]);
      }
    } finally {
      setProjectConfigLoading(false);
    }
  };

  const getProjectAssetData = async () => {
    await fetchProjectAssetData(selectedProject);
  };

  const fetchSiteLocations = async () => {
    const siteLocation = await getSiteLocations(
      selectedProject[0].mviewProjectInfo.regionCode,
    );
    const sortedData = siteLocation.sort((a, b) =>
      a.code.localeCompare(b.code),
    );
    setLocations(sortedData);
  };

  const fetchDisciplines = async () => {
    const disciplines = await getDisciplines(
      selectedProject[0].mviewProjectInfo.regionCode,
    );
    const sortedData = disciplines.sort((a, b) =>
      a.description.localeCompare(b.description),
    );
    setDisciplines(sortedData);
  };

  const fetchMWHAssets = async () => {
    const mwhAssets = await getMWHAssets();
    const sortedData = mwhAssets.sort((a, b) => a.name.localeCompare(b.name));
    setMWHAssets(sortedData);
  };

  const fitGridColumns = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      // Keep all columns visible by fitting to the available viewport width.
      api.sizeColumnsToFit();
    },
    [gridApi],
  );

  const applyGridPageSizeMode = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      const allRowCount = Math.max(rowData?.length || 0, 1);

      if (gridPageSizeMode === "all") {
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", allRowCount);
      } else if (gridPageSizeMode === "auto") {
        api.setGridOption("paginationAutoPageSize", true);
      } else {
        const pageSize = Number(gridPageSizeMode) || 25;
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", pageSize);
      }

      api.paginationGoToFirstPage();
    },
    [gridApi, gridPageSizeMode, rowData],
  );

  useEffect(() => {
    applyGridPageSizeMode();
    fitGridColumns();
  }, [applyGridPageSizeMode, fitGridColumns]);

  const gridReady = (params) => {
    setGridApi(params.api);
    requestAnimationFrame(() => {
      fitGridColumns(params.api);
      applyGridPageSizeMode(params.api);
    });
  };

  const fetchAllSubmittals = async (projectId) => {
    const data = await getAllSubmittals(projectId);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: ALL_PROJECT_SUBMITTALS,
      }),
    );
  };

  const createSubmittal = async () => {
    setSubmitting(true);
    const selectedModel = gridApi.getSelectedRows()[0];
    const tempSubmittalData = {
      ...submittalData,
      selectedModel: selectedModel,
    };
    const addSubmittalMessage = await addTaskSubmittal(tempSubmittalData);
    window.alert(addSubmittalMessage.message);
    await fetchAllSubmittals(selectedProject[0].id);
    onClosesubmittalModal();
    setSubmitting(false);
  };

  const selectedDeleteHandler = () => {
    const selectedModels = gridApi.getSelectedRows();
    if (selectedModels.some((model) => model.liveSubmittal)) {
      alert(
        "You cannot delete/retire one or more selected models as they have a live submittal. Please close out the live submittal(s) and then try again.",
      );
      return;
    }

    setConfirmDeleteModalOpen(true);
  };

  const confirmDeleteModels = async () => {
    setDeleting(true);
    const selectedModels = gridApi.getSelectedRows();

    try {
      for (const selectedModel of selectedModels) {
        const selectedModelId = selectedModel.id;
        await deleteProjectAssetTasks(selectedModelId, selectedProject[0].id);
      }
      window.alert("Model(s) deleted/retired successfully.");
      await fetchProjectAssetData(selectedProject);
      await fetchAllDocs(selectedProject[0].id);
      setSelectedFiles([]);
      setConfirmDeleteModalOpen(false);
    } finally {
      setDeleting(false);
    }
  };

  const [colDefs] = useState([
    { field: "id", hide: true },
    {
      field: "asset",
      headerName: "Regional Designation",
      flex: 1.35,
      minWidth: 120,
    },
    {
      field: "mwhAssetName",
      headerName: "MWH Asset",
      flex: 1,
      minWidth: 95,
    },
    {
      field: "model",
      headerName: "Title",
      flex: 1,
      minWidth: 95,
    },
    { field: "discipline", flex: 0.8, minWidth: 90 },
    { field: "documentNumber", flex: 1.2, minWidth: 105 },
    // { field: "company", width: 220 },
    { field: "status", flex: 0.8, minWidth: 90 },
    { headerName: "Revision" ,   valueGetter: (p) => {
          const currentStatus = regionalStatuses.find(
            (s) => s.code === p.data.status,
          );
          if (currentStatus?.published) {
            return p.data.publishedRevision;
          }

          return p.data.sharedRevision;
        },flex: 0.8, minWidth: 90 },
    
    { field: "lastUpdated", headerName: "Last Updated", flex: 1, minWidth: 105 },
    {
      field: "history",
      headerName: "Published Model",
      flex: 0.75,
      minWidth: 84,
      //center align the content
      cellStyle: { textAlign: "center" },
      //if true show checkmark if false show x mark
      cellRenderer: (params) =>
        params.value ? (
          <span style={{ color: "green", fontSize: "18px" }}>&#10003;</span>
        ) : (
          <span style={{ color: "red", fontSize: "18px" }}>&#10007;</span>
        ),
    },
    {
      field: "retired",
      flex: 0.65,
      minWidth: 74, //center align the content
      cellStyle: { textAlign: "center" },
      //if true show checkmark if false show x mark
      cellRenderer: (params) =>
        params.value ? (
          <span style={{ color: "green", fontSize: "18px" }}>&#10003;</span>
        ) : (
          <span style={{ color: "red", fontSize: "18px" }}>&#10007;</span>
        ),
    },
    {
      field: "liveSubmittal",
      flex: 0.8,
      minWidth: 86, //center align the content
      cellStyle: { textAlign: "center" },
      //if true show checkmark if false show x mark
      cellRenderer: (params) =>
        params.value ? (
          <span style={{ color: "green", fontSize: "18px" }}>&#10003;</span>
        ) : (
          <span style={{ color: "red", fontSize: "18px" }}>&#10007;</span>
        ),
    },
  ]);

  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      filter: "agSetColumnFilter",
      suppressSizeToFit: false,
    }),
    [],
  );

  const selectionChanged = () => {
    setSelectedFiles(gridApi.getSelectedRows());
  };

  const addTaskHandler = async () => {
    if (!newModelData) {
      alert("Please fill in the model creation form.");
      return;
    }

    setIsSavingModels(true);
    setSurveyProgress(0);

    const tempNewModelData = { ...newModelData };
    const docNumberMap = {};
    let maxNumber = 0;
    if (Array.isArray(mviewDocNumbers)) {
      mviewDocNumbers.forEach((item) => {
        docNumberMap[item.discipline] = parseInt(item.docNumber, 10) || 0;
        if (docNumberMap[item.discipline] > maxNumber) {
          maxNumber = docNumberMap[item.discipline];
        }
      });
    }
    let tasksToAdd = [];
    if (
      tempNewModelData.disciplines &&
      Array.isArray(tempNewModelData.disciplines)
    ) {
      tempNewModelData.disciplines.forEach((discipline) => {
        // addDrawingSet(
        //   selectedProject[0].id,
        //   tempNewModelData.asset,
        //   tempNewModelData.assetFilters,
        //   tempNewModelData.company,
        //   tempNewModelData.location,
        //   tempNewModelData.modelName,
        //   discipline,
        // );
        for (let i = 0; i < (discipline.quantity || 0); i++) {
          tasksToAdd.push({
            asset: tempNewModelData.asset,
            assetFilters: tempNewModelData.assetFilters,
            mwhAssetName: tempNewModelData.mwhAssetName,
            company: tempNewModelData.company,
            location: tempNewModelData.location,
            modelName: tempNewModelData.modelName,
            discipline,
            subContractorNumber: tempNewModelData.subContractorNumber ?? null,
            newNumber: (docNumberMap[discipline.description] || 0) + i + 1,
          });
        }
      });
    }
    // Now you can use tasksToAdd to send to the server, e.g. with Promise.all or a loop

    const tempTotalTasks = tasksToAdd.length;
    setTotalTasks(tempTotalTasks);

    const updateProgress = () => {
      const completedCount = surveyProgress + 1;
      setSurveyProgress(completedCount); // If you want to show progress in UI
      // Optionally, show a toast or update a progress bar here
    };
    onCloseModal();
    Promise.all(
      tasksToAdd.map(async (task, i) => {
        return addTask(
          selectedProject[0].id,
          userDetails.email,
          task,
          maxNumber + i + 1,
          selectedProject[0].mviewProjectInfo.region.code,
        ).then(() => {
          updateProgress();
        });
      }),
    )
      .then(async (results) => {
        setIsSavingModels(false);
        dispatch(
          updateGlobalState({
            value: "Model Upload",
            stateName: TOAST_TITLE,
          }),
        );
        dispatch(
          updateGlobalState({
            value: "Uploading of models is complete.",
            stateName: TOAST_BODY,
          }),
        );
        dispatch(
          updateGlobalState({
            value: true,
            stateName: SHOW_TOAST,
          }),
        );
        await fetchProjectAssetData(selectedProject);
        await fetchAllDocs(selectedProject[0].id);
      })
      .catch((error) => {});
  };

  const addSurveyHandler = async () => {
    setIsSaving(true);
    setSurveyProgress(0);

    // Loop over defaultTasks and track uploads
    // for (let i = 0; i < (surveyModelData?.survey?.data?.defaultTasks?.length || 0); i++) {
    //   await addSurvey(
    //   selectedProject[0].id,
    //   surveyModelData,
    //   userDetails.email,
    //   mviewDocNumbers,
    //   selectedProject[0].mviewProjectInfo.region.code
    //   );
    //   modelsUploaded++;
    //   // Optionally, you can update UI or log progress here
    // }
    // Build a map of discipline to current docNumber
    const tempSurveyData = { ...surveyModelData };
    const docNumberMap = {};
    let maxNumber = 0;
    if (Array.isArray(mviewDocNumbers)) {
      mviewDocNumbers.forEach((item) => {
        docNumberMap[item.discipline] = parseInt(item.docNumber, 10) || 0;
        if (docNumberMap[item.discipline] > maxNumber) {
          maxNumber = docNumberMap[item.discipline];
        }
      });
    }

    // Add newNumber to each task, incrementing per discipline
    if (
      tempSurveyData?.survey?.data?.defaultTasks &&
      Array.isArray(tempSurveyData.survey.data.defaultTasks)
    ) {
      tempSurveyData.survey.data.defaultTasks.forEach((task) => {
        const discipline = task.discipline.description;
        if (!docNumberMap[discipline]) {
          docNumberMap[discipline] = 0;
        } else {
          docNumberMap[discipline] += 1;
        }
        task = {
          ...task,
          newNumber: docNumberMap[discipline],
        };
        // task.newNumber = docNumberMap[discipline];
      });
    }

    const tempTotalTasks =
      tempSurveyData?.survey?.data?.defaultTasks?.length || 0;
    // setIsSaving(true);
    setTotalTasks(tempTotalTasks);

    // Optionally, you can use a state to track progress and show it in the UI

    const updateProgress = () => {
      const completedCount = surveyProgress + 1;
      setSurveyProgress(completedCount); // If you want to show progress in UI
      // Optionally, show a toast or update a progress bar here
    };

    onCloseSurveyModal();
    Promise.all(
      tempSurveyData?.survey?.data?.defaultTasks.map(async (task, i) => {
        return addSurvey(
          selectedProject[0].id,
          task,
          userDetails.email,
          maxNumber + i + 1,
          selectedProject[0].mviewProjectInfo.region.code,
          tempSurveyData?.company,
          tempSurveyData?.survey?.data?.asset,
          tempSurveyData?.subContractorNumber,
        ).then(() => {
          updateProgress();
        });
      }),
    )
      .then(async (results) => {
        setIsSaving(false);
        dispatch(
          updateGlobalState({
            value: "Survey Model Upload",
            stateName: TOAST_TITLE,
          }),
        );
        dispatch(
          updateGlobalState({
            value: "Uploading of survey models is complete.",
            stateName: TOAST_BODY,
          }),
        );
        dispatch(
          updateGlobalState({
            value: true,
            stateName: SHOW_TOAST,
          }),
        );
        await fetchProjectAssetData(selectedProject);

        await fetchAllDocs(selectedProject[0].id);
      })
      .catch((error) => {});

    // const data = await addSurvey(
    //   selectedProject[0].id,
    //   surveyModelData,
    //   userDetails.email,
    //   mviewDocNumbers,
    //   selectedProject[0].mviewProjectInfo.region.code
    // );
    // setIsSaving(false);
    // onCloseSurveyModal();
    // alert(data.data.message);
    // await fetchProjectAssetData(selectedProject);

    // await fetchAllDocs(selectedProject[0].id);
  };

  const addAssetHandler = async () => {
    setIsSaving(true);
    const data = await addAsset(
      selectedProject[0].id,
      newModelData,
      userDetails.email,
      mviewDocNumbers,
      selectedProject[0].mviewProjectInfo.region.code,
    );
    setIsSaving(false);
    onCloseAssetModal();
    alert(data.data.message);
    await fetchProjectAssetData(selectedProject);

    await fetchAllDocs(selectedProject[0].id);
  };

  const onCloseModal = () => {
    setModal(false);
    setNewModelData();
    setIncludeDefaultModels(false);
  };

  const onCloseAssetModal = () => {
    setAssetModal(false);
    setNewModelData();
  };

  const onClosesubmittalModal = () => {
    setSubmittalModal(false);
    setSubmittalData();
  };

  const onCloseSurveyModal = () => {
    setSurveyModal(false);
    setSurveyModelData();
    // setIncludeDefaultModels(false);
  };
  const gridRef = useRef();

  useEffect(() => {
    // const tempMviewDocNumbers = allDocs.map((doc) => {
    //   const tempNumber =
    //     doc.docNumber.split("-")[doc.docNumber.split("-").length - 1];
    //   return tempNumber;
    // });
    const tempMviewDocNumbers = [];
    if (allDocs && allDocs.length > 0) {
      const grouped = allDocs.reduce((acc, doc) => {
        const discipline = doc.discipline || "Unknown";
        if (!acc[discipline]) acc[discipline] = [];
        acc[discipline].push(doc);
        return acc;
      }, {});
      Object.values(grouped).forEach((docs) => {
        const maxDoc = docs.reduce((max, curr) => {
          const currNum = parseInt(curr.docNumber.split("-").pop(), 10);
          const maxNum = parseInt(max.docNumber.split("-").pop(), 10);
          return currNum > maxNum ? curr : max;
        }, docs[0]);
        tempMviewDocNumbers.push({
          discipline: maxDoc.discipline,
          docNumber: maxDoc.docNumber.split("-").pop(),
        });
      });
    }
    setMviewDocNumbers(tempMviewDocNumbers);
  }, [allDocs]);

  const modelInfoChangeHandler = (e, type) => {
    if (e.target) {
      setNewModelData({
        ...newModelData,
        [type]: e.target.value,
      });
    } else {
      setNewModelData({
        ...newModelData,
        [type]: e,
      });
    }
  };

  const surveyModelInfoChangeHandler = (e, type) => {
    if (e.target) {
      setSurveyModelData({
        ...surveyModelData,
        [type]: e.target.value,
      });
    } else {
      setSurveyModelData({
        ...surveyModelData,
        [type]: e,
      });
    }
  };

  const submittalInfoChangeHandler = (e, type) => {
    const tempComment = {
      id: 1,
      user: userDetails.email,
      date: new Date().toISOString(),
    };
    if (e.target) {
      if (type === "comment") {
        setSubmittalData({
          ...submittalData,
          [type]: { ...tempComment, comment: e.target.value },
        });
      } else {
        setSubmittalData({
          ...submittalData,
          [type]: e.target.value,
        });
      }
    } else {
      setSubmittalData({
        ...submittalData,
        [type]: e.value,
      });
    }
  };

  const fetchAllDocs = async (projectId) => {
    const allDocs = await getProjectAssetTasks(projectId);
    const docsArray = Array.isArray(allDocs) ? allDocs : [];
    const sortedData = docsArray.sort((a, b) =>
      a.docNumber.localeCompare(b.docNumber),
    );
    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ALL_DOCS,
      }),
    );
  };

  const checkRequired = (type) => {
    if (regionData && regionData.docNumberFormat) {
      if (regionData.docNumberFormat.includes(type)) {
        return (
          newModelData?.[type] !== undefined && newModelData?.[type] !== null
        );
      } else {
        return true;
      }
    }
    return false;
  };

  const fetchRegionAssetFilters = async (
    regionCode,
    id,
    levelIndex,
    tempAssetFilters,
  ) => {
    const assetFiltersTemp = await getAssetFilters(regionCode, id);
    const newAssetFilters = [
      ...assetFilters.filter((o) => o.levelIndex <= levelIndex),
      ...assetFiltersTemp?.data,
    ];
    const levels = [
      ...new Set(
        newAssetFilters
          .sort((a, b) => a.levelIndex - b.levelIndex)
          .map((filter) => filter.level),
      ),
    ];
    //Set the asset filter levels to be all the unique levels from the asset filters
    setAssetFilterLevels(levels);
    setAssetFilters(newAssetFilters);
    if (!assetFiltersTemp?.data?.length > 0) {
      // get highest level index and data and fetch assets with that level index
      const highestLevelIndex = Math.max(
        ...assetFilters.map((filter) => filter.levelIndex),
      );

      // Find all assetFilter objects with the highest levelIndex
      const highestLevelFilters = assetFilters.filter(
        (filter) => filter.levelIndex === highestLevelIndex,
      );
      let assignedData = null;
      if (highestLevelFilters.length > 0) {
        const levelCamelCase = highestLevelFilters[0].level
          .replace(/\s+/g, "")
          .replace(/^[A-Z]/, (m) => m.toLowerCase());

        assignedData = tempAssetFilters[levelCamelCase] || null;
        // You can now use highestLevelFilters and assignedData as needed
      }
      //use assignedData to fetch assets
      const tempAssets = await getAllRegionAssets(
        selectedProject[0].mviewProjectInfo.regionCode,
        assignedData?.data?.code,
      );

      const sortedData = tempAssets.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      dispatch(
        updateGlobalState({
          value: sortedData,
          stateName: ALL_ASSETS,
        }),
      );
    }
  };

  return (
    <div className="project-config-page">
      {/* <Navbar /> */}
      <Container fluid className="project-config-shell">
        <h1 className="project-config-title">Project Configuration</h1>
        {userDetails?.projectAdmin && (
          <>
            <Row>
              <Col
                className="project-config-actions"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  paddingTop: "8px",
                }}
              >
                <>
                  {allSurveys?.length > 0 && (
                    <>
                      <Button
                        className="project-config-action-btn mwh-btn-success"
                        variant="outline-success"
                        size="sm"
                        style={{ width: "150px" }}
                        onClick={() => {
                          setSurveyModal(true);
                        }}
                      >
                        {isSaving ? (
                          <span>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                            {`Survey upload progress: ${surveyProgress} / ${totalTasks}`}
                          </span>
                        ) : (
                          <span>Add Project Survey</span>
                        )}
                      </Button>
                    </>
                  )}
                  {/* <Button
                    variant="outline-success"
                    size="sm"
                    style={{ width: "150px" }}
                    onClick={() => {
                      setAssetModal(true);
                    }}
                  >
                    Add new asset
                  </Button> */}
                  <Button
                    className="project-config-action-btn mwh-btn-success"
                    variant="outline-success"
                    size="sm"
                    style={{ width: "150px" }}
                    onClick={() => {
                      setModal(true);
                    }} // open model for askingquestion on model info.
                    // disabled={!selectedAsset.value}
                  >
                    {isSavingModels ? (
                      <span>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </span>
                    ) : (
                      <span>Add New 3D Model</span>
                    )}
                  </Button>

                  {/* <Button
                    variant="outline-danger"
                    size="sm"
                    style={{ width: "150px" }}
                    onClick={selectedDeleteAssetHandler}
                    disabled={selectedFiles?.length === 0}
                  >
                    {deletingAsset ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span>Delete/Retire Asset</span>
                    )}
                  </Button> */}
                </>

                {/* {selectedFiles.length !== 0 && ( */}
                <>
                  <Button
                    className="project-config-action-btn mwh-btn-warning"
                    variant="outline-warning"
                    size="sm"
                    style={{ width: "150px" }}
                    onClick={() => {
                      setSubmittalModal(true);
                    }}
                    disabled={
                      selectedFiles?.length === 0 ||
                      selectedFiles?.length > 1 ||
                      selectedFiles[0]?.retired ||
                      selectedFiles[0]?.liveSubmittal
                    }
                  >
                    {submitting ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span>Create Submittal</span>
                    )}
                  </Button>
                  {selectedFiles[0]?.history ? (
                    <Button
                      className="project-config-action-btn mwh-btn-danger"
                      variant="outline-danger"
                      size="sm"
                      style={{ width: "150px" }}
                      onClick={selectedDeleteHandler}
                      disabled={selectedFiles?.length === 0}
                    >
                      {deleting ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <span>Retire 3D Model</span>
                      )}
                    </Button>
                  ) : (
                    <Button
                      className="project-config-action-btn mwh-btn-danger"
                      variant="outline-danger"
                      size="sm"
                      style={{ width: "150px" }}
                      onClick={selectedDeleteHandler}
                      disabled={selectedFiles?.length === 0}
                    >
                      {deleting ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <span>Delete 3D Model</span>
                      )}
                    </Button>
                  )}
                  
                </>
                {/* )} */}
              </Col>
            </Row>
          </>
        )}
        <Row className="project-config-grid-row">
          <div className="project-config-grid-wrap">
            <div className="project-config-grid-table">
              {projectConfigLoading ? (
                <LoadingScreen
                  input="Loading Project Data"
                  width="12"
                  height="100%"
                  marginTop="6%"
                  variant="properties"
                  subtitle="Loading project configuration..."
                  transparent={true}
                />
              ) : (
                <>
                  <AgGridReact
                    theme={agGridTheme}
                    rowData={rowData}
                    ref={gridRef}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    paginationAutoPageSize={gridPageSizeMode === "auto"}
                    paginationPageSizeSelector={false}
                    onGridReady={gridReady}
                    onGridSizeChanged={(params) => {
                      fitGridColumns(params.api);
                      if (gridPageSizeMode === "auto") {
                        applyGridPageSizeMode(params.api);
                      }
                    }}
                    onFirstDataRendered={(params) => {
                      fitGridColumns(params.api);
                      applyGridPageSizeMode(params.api);
                    }}
                    onSelectionChanged={selectionChanged}
                    gridOptions={agGridOptionsMultiple}
                  />
                  <div className="project-config-grid-rows-view">
                    <Form.Label className="mb-0 me-2">Page size</Form.Label>
                    <Form.Select
                      size="sm"
                      value={gridPageSizeMode}
                      onChange={(e) => {
                        setGridPageSizeMode(e.target.value);
                      }}
                      style={{ maxWidth: "180px" }}
                    >
                      <option value="auto">Auto</option>
                      <option value="25">25 per page</option>
                      <option value="50">50 per page</option>
                      <option value="100">100 per page</option>
                      <option value="all">All (scroll)</option>
                    </Form.Select>
                  </div>
                </>
              )}
            </div>
          </div>
        </Row>
      </Container>
      {/* MODALS */}
      {/* NEW MODEL MODAL */}
      <Modal
        show={modal}
        onHide={onCloseModal}
        dialogClassName="model-creation-modal project-config-modal"
        centered
      >
        <Modal.Header className="project-config-modal__header">
          <Modal.Title>3D Model Creation Form</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onCloseModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-config-modal__body">
          <div className="row">
            <div className="col ">
              <Form.Label>
                Model Title
                <MandatoryFieldIndicator />
              </Form.Label>
              <Form.Control
                type="text"
                size="sm"
                value={newModelData?.modelName ?? ""}
                onChange={(e) => {
                  modelInfoChangeHandler(e, "modelName");
                }}
              />

              {selectedProject[0]?.mviewProjectInfo?.region?.assetFilterReq ? (
                <>
                  {assetFilterLevels?.map((level, i) => (
                    <Row key={level + i}>
                      <Col>
                        <label className="mt-1">
                          {`${level}`}
                          <MandatoryFieldIndicator />
                        </label>
                        <div>
                          <Select
                            className="basic-single mb-2"
                            options={assetFilters
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .filter((f) => f.level === level)
                              .map((filter) => ({
                                value: filter.code,
                                label: filter.name,
                                data: filter,
                              }))}
                            classNamePrefix="project-config-select"
                            value={
                              newModelData?.assetFilters?.[
                                level
                                  .replace(/\s+/g, "")
                                  .replace(/^[A-Z]/, (m) => m.toLowerCase())
                              ] || null
                            }
                            onChange={(filter) => {
                              let levelCamelCase = level
                                .replace(/\s+/g, "")
                                .replace(/^[A-Z]/, (m) => m.toLowerCase());
                              const tempAssetFilters = {
                                ...newModelData?.assetFilters,
                                [levelCamelCase]: filter,
                              };

                              let tempObjectInput = {};
                              Object.keys(tempAssetFilters).forEach((key) => {
                                if (
                                  tempAssetFilters[key].data.levelIndex <=
                                  filter.data.levelIndex
                                ) {
                                  tempObjectInput[key] = tempAssetFilters[key];
                                }
                              });
                              setNewModelData({
                                ...newModelData,
                                assetFilters: tempObjectInput,
                                asset: null,
                              });
                              fetchRegionAssetFilters(
                                null,
                                filter.data.id,
                                filter.data.levelIndex,
                                tempObjectInput,
                              );
                            }}
                            isSearchable={true}
                          />
                        </div>
                      </Col>
                    </Row>
                  ))}
                  {(() => {
                    if (assetFilterLevels.length > 0) {
                      const highestLevel =
                        assetFilterLevels[assetFilterLevels.length - 1];
                      const highestLevelKey = highestLevel
                        .replace(/\s+/g, "")
                        .replace(/^[A-Z]/, (m) => m.toLowerCase());
                      if (
                        newModelData?.assetFilters &&
                        newModelData.assetFilters[highestLevelKey]
                      ) {
                        return (
                          <>
                            <div className="row">
                              <div className="col ">
                                <Form.Label className="mt-1">
                                  Regional Designation
                                  <MandatoryFieldIndicator />
                                </Form.Label>
                                <Select
                                  className="mb-2"
                                  menuPortalTarget={document.body}
                                  classNamePrefix="project-config-select"
                                  onChange={(e) => {
                                    modelInfoChangeHandler(e, "asset");
                                  }}
                                  options={allAssets?.map((asset) => {
                                    return {
                                      label: asset.name,
                                      value: asset.name,
                                      data: asset,
                                    };
                                  })}
                                  value={newModelData?.asset}
                                />
                              </div>
                            </div>
                            <Row>
                              <Col>
                                <label className="mt-1">
                                  MWH Asset Name
                                  <MandatoryFieldIndicator />
                                </label>
                                <div>
                                  <Select
                                    className="basic-single mb-2"
                                    options={mwhAssets
                                      ?.slice()
                                      .filter((o) => o.name !== "General")
                                      .map((asset) => ({
                                        value: asset.name,
                                        label: asset.name,
                                        data: asset,
                                      }))}
                                    classNamePrefix="project-config-select"
                                    value={newModelData?.mwhAssetName}
                                    onChange={(e) => {
                                      modelInfoChangeHandler(e, "mwhAssetName");
                                    }}
                                    isSearchable={true}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </>
                        );
                      }
                    }
                    return null;
                  })()}
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col ">
                      <Form.Label className="mt-1">
                        Regional Designation
                        <MandatoryFieldIndicator />
                      </Form.Label>
                      {selectedProject[0]?.mviewProjectInfo?.region?.code ===
                      "UU" ? (
                        <Select
                          className="mb-2"
                          menuPortalTarget={document.body}
                          classNamePrefix="project-config-select"
                          onChange={(e) => {
                            modelInfoChangeHandler(e, "asset");
                          }}
                          options={allAssets
                            ?.slice()
                            ?.sort((a, b) => a.code.localeCompare(b.code))
                            ?.map((asset) => {
                              return {
                                label: `${asset.code} - ${asset.name}`,
                                value: `${asset.code} - ${asset.name}`,
                                data: asset,
                              };
                            })}
                          value={newModelData?.asset}
                        />
                      ) : (
                        <Select
                          className="mb-2"
                          menuPortalTarget={document.body}
                          classNamePrefix="project-config-select"
                          onChange={(e) => {
                            modelInfoChangeHandler(e, "asset");
                          }}
                          options={allAssets
                            ?.sort((a, b) => a.name.localeCompare(b.name))
                            ?.map((asset) => {
                              return {
                                label: asset.name,
                                value: asset.name,
                                data: asset,
                              };
                            })}
                          value={newModelData?.asset}
                        />
                      )}
                    </div>
                  </div>
                  <Row>
                    <Col>
                      <label className="mt-1">
                        MWH Asset Name
                        <MandatoryFieldIndicator />
                      </label>
                      <div>
                        <Select
                          className="basic-single mb-2"
                          options={mwhAssets
                            ?.slice()
                            .filter((o) => o.name !== "General")
                            .map((asset) => ({
                              value: asset.name,
                              label: asset.name,
                              data: asset,
                            }))}
                          classNamePrefix="project-config-select"
                          value={newModelData?.mwhAssetName}
                          onChange={(e) => {
                            modelInfoChangeHandler(e, "mwhAssetName");
                          }}
                          isSearchable={true}
                        />
                      </div>
                    </Col>
                  </Row>
                </>
              )}

              {/* ASSET EXTRA DATA */}
              {selectedProject[0]?.mviewProjectInfo?.region
                ?.assetExtraDataReq &&
                newModelData?.asset && (
                  <Row>
                    <Col>
                      <Form.Label className="mt-1">
                        {`${newModelData?.asset?.data.extraData[0]?.level}`}
                      </Form.Label>
                      <div>
                        <Select
                          className="mb-2"
                          options={newModelData?.asset?.data.extraData
                            .sort((a, b) => a.code.localeCompare(b.code))
                            .map((filter) => ({
                              value: filter.code,
                              label: filter.name,
                              data: filter,
                            }))}
                          classNamePrefix="project-config-select"
                          value={newModelData?.AED1 ?? null}
                          onChange={(e) => {
                            modelInfoChangeHandler(e, "AED1");
                          }}
                          isSearchable={true}
                        />
                      </div>
                    </Col>
                  </Row>
                )}
              {selectedProject[0]?.mviewProjectInfo?.region
                ?.regionAssetExtraDataReq &&
                checkRequired("AED1") &&
                regionalTopLevels.map((level, i) => {
                  return (
                    <Row key={level + i}>
                      <Col>
                        <Form.Label className="mt-1">{`${level}`}</Form.Label>
                        <div>
                          <Select
                            className="mb-2"
                            options={regionData?.assetExtraData
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .filter((filter) => filter.level === level)
                              .map((filter) => ({
                                value:
                                  filter.regionCode === "UU"
                                    ? `${filter.code} - ${filter.name}`
                                    : filter.name,
                                label:
                                  filter.regionCode === "UU"
                                    ? `${filter.code} - ${filter.name}`
                                    : filter.name,
                                data: filter,
                              }))}
                            classNamePrefix="project-config-select"
                            value={newModelData?.["RAED" + (i + 1)] ?? null}
                            onChange={(e) => {
                              modelInfoChangeHandler(e, "RAED" + (i + 1));
                            }}
                            isSearchable={true}
                          />
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              {regionData &&
                regionData.docNumberFormat &&
                regionData.docNumberFormat.split("-").includes("LC") && (
                  <>
                    <Form.Label className="mt-1">
                      Asset Location
                      <MandatoryFieldIndicator />
                    </Form.Label>
                    <Select
                      className="mb-2"
                      menuPortalTarget={document.body}
                      classNamePrefix="project-config-select"
                      onChange={(e) => {
                        modelInfoChangeHandler(e, "location");
                      }}
                      options={locations?.map((location) => {
                        return {
                          label: location.description,
                          value: location.description,
                          data: location,
                        };
                      })}
                      value={newModelData?.location}
                    />
                  </>
                )}
              {regionData &&
                regionData.docNumberFormat &&
                regionData.docNumberFormat.split("-").includes("CC") && (
                  <>
                    <Form.Label className="mt-1">
                      Company Responsible
                      <MandatoryFieldIndicator />
                    </Form.Label>
                    <Select
                      className="mb-2"
                      menuPortalTarget={document.body}
                      classNamePrefix="project-config-select"
                      onChange={(e) => {
                        modelInfoChangeHandler(e, "company");
                      }}
                      options={companyOptions?.map((company) => {
                        return {
                          label: company.name,
                          value: company.name,
                          data: company,
                        };
                      })}
                      value={newModelData?.company}
                    />
                  </>
                )}
              {regionData &&
                regionData.docNumberFormat &&
                regionData.docNumberFormat.split("-").includes("DC") &&
                newModelData?.company?.data && (
                  <>
                    {selectedProject[0]?.mviewProjectInfo?.regionCode ===
                    "UU" ? (
                      // UU region logic
                      ["MWH", "MWD", "MWT"].includes(
                        newModelData?.company?.data?.code,
                      ) ? (
                        <>
                          <Form.Label className="mt-1">
                            How many models of each discipline do you require?
                            <MandatoryFieldIndicator />
                          </Form.Label>
                          <div
                            className="project-config-matrix-wrap"
                            style={{ overflowX: "auto" }}
                          >
                            <table
                              className="project-config-matrix-table"
                              style={{ minWidth: 400 }}
                            >
                              <thead>
                                <tr>
                                  {disciplines
                                    ?.filter(
                                      (d) =>
                                        d.description !== "Sub-contractor" &&
                                        d.description !== "Surveyor",
                                    )
                                    .map((discipline) => (
                                      <th
                                        key={discipline.description}
                                        className="project-config-matrix-table__head"
                                        style={{ textAlign: "center" }}
                                      >
                                        {discipline.description}
                                      </th>
                                    ))}
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {disciplines
                                    ?.filter(
                                      (d) =>
                                        d.description !== "Sub-contractor" &&
                                        d.description !== "Surveyor",
                                    )
                                    .map((discipline) => {
                                      const currentValue =
                                        newModelData?.disciplines?.find(
                                          (d) => d.id === discipline.id,
                                        )?.quantity ?? 0;
                                      return (
                                        <td
                                          key={discipline.description}
                                          className="project-config-matrix-table__cell"
                                          style={{ textAlign: "center" }}
                                        >
                                          <div
                                            className="project-config-stepper"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Button
                                              className="project-config-stepper__btn project-config-stepper__btn--minus"
                                              variant="outline-danger"
                                              size="sm"
                                              style={{
                                                minWidth: 28,
                                                padding: 0,
                                                marginRight: 4,
                                              }}
                                              onClick={() => {
                                                const value = Math.max(
                                                  0,
                                                  currentValue - 1,
                                                );
                                                setNewModelData({
                                                  ...newModelData,
                                                  disciplines: [
                                                    ...(newModelData?.disciplines?.map(
                                                      (d) =>
                                                        d.id === discipline.id
                                                          ? {
                                                              ...d,
                                                              quantity: value,
                                                            }
                                                          : d,
                                                    ) ?? []),
                                                    ...(newModelData?.disciplines?.some(
                                                      (d) =>
                                                        d.id === discipline.id,
                                                    )
                                                      ? []
                                                      : [
                                                          {
                                                            ...discipline,
                                                            quantity: value,
                                                          },
                                                        ]),
                                                  ],
                                                });
                                              }}
                                              disabled={currentValue <= 0}
                                              tabIndex={-1}
                                            >
                                              -
                                            </Button>
                                            <input
                                              className="form-control form-control-sm project-config-stepper__input"
                                              id="amountInput"
                                              type="number"
                                              min="0"
                                              step="1"
                                              max="5"
                                              style={{
                                                width: 40,
                                                margin: "0 4px",
                                                textAlign: "center",
                                              }}
                                              value={currentValue}
                                              onChange={(e) => {
                                                const value = Math.max(
                                                  0,
                                                  parseInt(
                                                    e.target.value,
                                                    10,
                                                  ) || 0,
                                                );
                                                setNewModelData({
                                                  ...newModelData,
                                                  disciplines: [
                                                    ...(newModelData?.disciplines?.map(
                                                      (d) =>
                                                        d.id === discipline.id
                                                          ? {
                                                              ...d,
                                                              quantity: value,
                                                            }
                                                          : d,
                                                    ) ?? []),
                                                    ...(newModelData?.disciplines?.some(
                                                      (d) =>
                                                        d.id === discipline.id,
                                                    )
                                                      ? []
                                                      : [
                                                          {
                                                            ...discipline,
                                                            quantity: value,
                                                          },
                                                        ]),
                                                  ],
                                                });
                                              }}
                                            />
                                            <Button
                                              className="project-config-stepper__btn project-config-stepper__btn--plus"
                                              variant="outline-success"
                                              size="sm"
                                              style={{
                                                minWidth: 28,
                                                padding: 0,
                                                marginLeft: 4,
                                              }}
                                              onClick={() => {
                                                const value = Math.min(
                                                  5,
                                                  currentValue + 1,
                                                );
                                                setNewModelData({
                                                  ...newModelData,
                                                  disciplines: [
                                                    ...(newModelData?.disciplines?.map(
                                                      (d) =>
                                                        d.id === discipline.id
                                                          ? {
                                                              ...d,
                                                              quantity: value,
                                                            }
                                                          : d,
                                                    ) ?? []),
                                                    ...(newModelData?.disciplines?.some(
                                                      (d) =>
                                                        d.id === discipline.id,
                                                    )
                                                      ? []
                                                      : [
                                                          {
                                                            ...discipline,
                                                            quantity: value,
                                                          },
                                                        ]),
                                                  ],
                                                });
                                              }}
                                              disabled={currentValue >= 5}
                                              tabIndex={-1}
                                            >
                                              +
                                            </Button>
                                          </div>
                                        </td>
                                      );
                                    })}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </>
                      ) : (
                        <>
                          <Form.Label className="mt-1">
                            How many Sub-contractor models do you require?
                            <MandatoryFieldIndicator />
                          </Form.Label>
                          <div
                            className="project-config-matrix-wrap"
                            style={{ overflowX: "auto" }}
                          >
                            <div>
                              <table
                                className="project-config-matrix-table project-config-matrix-table--compact"
                                style={{ minWidth: 200, maxWidth: 400 }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      className="project-config-matrix-table__head"
                                      style={{ textAlign: "center" }}
                                    >
                                      Sub-contractor
                                    </th>
                                    <th
                                      className="project-config-matrix-table__head"
                                      style={{ textAlign: "center" }}
                                    >
                                      Sub-contractor Number
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td
                                      className="project-config-matrix-table__cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      <div
                                        className="project-config-stepper"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <Button
                                          className="project-config-stepper__btn project-config-stepper__btn--minus"
                                          variant="outline-danger"
                                          size="sm"
                                          style={{
                                            minWidth: 28,
                                            padding: 0,
                                            marginRight: 4,
                                          }}
                                          onClick={() => {
                                            const subContractorDiscipline =
                                              disciplines?.find(
                                                (d) =>
                                                  d.description ===
                                                  "Sub-contractor",
                                              );
                                            const currentValue =
                                              newModelData?.disciplines?.find(
                                                (d) =>
                                                  d.id ===
                                                  subContractorDiscipline?.id,
                                              )?.quantity ?? 0;
                                            const value = Math.max(
                                              0,
                                              currentValue - 1,
                                            );
                                            setNewModelData({
                                              ...newModelData,
                                              disciplines: [
                                                ...(newModelData?.disciplines?.map(
                                                  (d) =>
                                                    d.id ===
                                                    subContractorDiscipline?.id
                                                      ? {
                                                          ...d,
                                                          quantity: value,
                                                        }
                                                      : d,
                                                ) ?? []),
                                                ...(newModelData?.disciplines?.some(
                                                  (d) =>
                                                    d.id ===
                                                    subContractorDiscipline?.id,
                                                )
                                                  ? []
                                                  : [
                                                      {
                                                        ...subContractorDiscipline,
                                                        quantity: value,
                                                      },
                                                    ]),
                                              ],
                                            });
                                          }}
                                          disabled={
                                            (newModelData?.disciplines?.find(
                                              (d) =>
                                                d.id ===
                                                disciplines?.find(
                                                  (d2) =>
                                                    d2.description ===
                                                    "Sub-contractor",
                                                )?.id,
                                            )?.quantity ?? 0) <= 0
                                          }
                                          tabIndex={-1}
                                        >
                                          -
                                        </Button>
                                        <input
                                          className="form-control form-control-sm project-config-stepper__input"
                                          id="subContractorAmountInput"
                                          type="number"
                                          min="0"
                                          step="1"
                                          max="5"
                                          style={{
                                            width: 40,
                                            margin: "0 4px",
                                            textAlign: "center",
                                          }}
                                          value={
                                            newModelData?.disciplines?.find(
                                              (d) =>
                                                d.id ===
                                                disciplines?.find(
                                                  (d2) =>
                                                    d2.description ===
                                                    "Sub-contractor",
                                                )?.id,
                                            )?.quantity ?? 0
                                          }
                                          onChange={(e) => {
                                            const subContractorDiscipline =
                                              disciplines?.find(
                                                (d) =>
                                                  d.description ===
                                                  "Sub-contractor",
                                              );
                                            const value = Math.max(
                                              0,
                                              parseInt(e.target.value, 10) || 0,
                                            );
                                            setNewModelData({
                                              ...newModelData,
                                              disciplines: [
                                                ...(newModelData?.disciplines?.map(
                                                  (d) =>
                                                    d.id ===
                                                    subContractorDiscipline?.id
                                                      ? {
                                                          ...d,
                                                          quantity: value,
                                                        }
                                                      : d,
                                                ) ?? []),
                                                ...(newModelData?.disciplines?.some(
                                                  (d) =>
                                                    d.id ===
                                                    subContractorDiscipline?.id,
                                                )
                                                  ? []
                                                  : [
                                                      {
                                                        ...subContractorDiscipline,
                                                        quantity: value,
                                                      },
                                                    ]),
                                              ],
                                            });
                                          }}
                                        />
                                        <Button
                                          className="project-config-stepper__btn project-config-stepper__btn--plus"
                                          variant="outline-success"
                                          size="sm"
                                          style={{
                                            minWidth: 28,
                                            padding: 0,
                                            marginLeft: 4,
                                          }}
                                          onClick={() => {
                                            const subContractorDiscipline =
                                              disciplines?.find(
                                                (d) =>
                                                  d.description ===
                                                  "Sub-contractor",
                                              );
                                            const currentValue =
                                              newModelData?.disciplines?.find(
                                                (d) =>
                                                  d.id ===
                                                  subContractorDiscipline?.id,
                                              )?.quantity ?? 0;
                                            const value = Math.min(
                                              5,
                                              currentValue + 1,
                                            );
                                            setNewModelData({
                                              ...newModelData,
                                              disciplines: [
                                                ...(newModelData?.disciplines?.map(
                                                  (d) =>
                                                    d.id ===
                                                    subContractorDiscipline?.id
                                                      ? {
                                                          ...d,
                                                          quantity: value,
                                                        }
                                                      : d,
                                                ) ?? []),
                                                ...(newModelData?.disciplines?.some(
                                                  (d) =>
                                                    d.id ===
                                                    subContractorDiscipline?.id,
                                                )
                                                  ? []
                                                  : [
                                                      {
                                                        ...subContractorDiscipline,
                                                        quantity: value,
                                                      },
                                                    ]),
                                              ],
                                            });
                                          }}
                                          disabled={
                                            (newModelData?.disciplines?.find(
                                              (d) =>
                                                d.id ===
                                                disciplines?.find(
                                                  (d2) =>
                                                    d2.description ===
                                                    "Sub-contractor",
                                                )?.id,
                                            )?.quantity ?? 0) >= 5
                                          }
                                          tabIndex={-1}
                                        >
                                          +
                                        </Button>
                                      </div>
                                    </td>
                                    <td
                                      className="project-config-matrix-table__cell"
                                      style={{ textAlign: "center" }}
                                    >
                                      <div
                                        className="project-config-stepper project-config-stepper--single"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <input
                                          className="form-control form-control-sm project-config-stepper__input project-config-stepper__input--subcontractor"
                                          id="subContractorNumberInput"
                                          type="number"
                                          min="1"
                                          max="99"
                                          style={{
                                            width: 60,
                                            // margin: "0 4px",
                                            textAlign: "center",
                                          }}
                                          value={
                                            newModelData?.subContractorNumber ??
                                            ""
                                          }
                                          onChange={(e) => {
                                            let value = e.target.value.replace(
                                              /\D/g,
                                              "",
                                            );
                                            value = Math.max(
                                              1,
                                              Math.min(99, Number(value) || 1),
                                            );
                                            setNewModelData({
                                              ...newModelData,
                                              subContractorNumber: value,
                                            });
                                          }}
                                          placeholder="1-99"
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )
                    ) : (
                      <table
                        className="project-config-matrix-table"
                        style={{ minWidth: 400 }}
                      >
                        <thead>
                          <tr>
                            {disciplines?.map((discipline) => (
                              <th
                                key={discipline.description}
                                className="project-config-matrix-table__head"
                                style={{ textAlign: "center" }}
                              >
                                {discipline.description}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {disciplines?.map((discipline) => {
                              const currentValue =
                                newModelData?.disciplines?.find(
                                  (d) => d.id === discipline.id,
                                )?.quantity ?? 0;
                              return (
                                <td
                                  key={discipline.description}
                                  className="project-config-matrix-table__cell"
                                  style={{ textAlign: "center" }}
                                >
                                  <div
                                    className="project-config-stepper"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Button
                                      className="project-config-stepper__btn project-config-stepper__btn--minus"
                                      variant="outline-danger"
                                      size="sm"
                                      style={{
                                        minWidth: 28,
                                        padding: 0,
                                        marginRight: 4,
                                      }}
                                      onClick={() => {
                                        const value = Math.max(
                                          0,
                                          currentValue - 1,
                                        );
                                        setNewModelData({
                                          ...newModelData,
                                          disciplines: [
                                            ...(newModelData?.disciplines?.map(
                                              (d) =>
                                                d.id === discipline.id
                                                  ? { ...d, quantity: value }
                                                  : d,
                                            ) ?? []),
                                            ...(newModelData?.disciplines?.some(
                                              (d) => d.id === discipline.id,
                                            )
                                              ? []
                                              : [
                                                  {
                                                    ...discipline,
                                                    quantity: value,
                                                  },
                                                ]),
                                          ],
                                        });
                                      }}
                                      disabled={currentValue <= 0}
                                      tabIndex={-1}
                                    >
                                      -
                                    </Button>
                                    <input
                                      className="form-control form-control-sm project-config-stepper__input"
                                      id="amountInput"
                                      type="number"
                                      min="0"
                                      step="1"
                                      max="5"
                                      style={{
                                        width: 40,
                                        margin: "0 4px",
                                        textAlign: "center",
                                      }}
                                      value={currentValue}
                                      onChange={(e) => {
                                        const value = Math.max(
                                          0,
                                          parseInt(e.target.value, 10) || 0,
                                        );
                                        setNewModelData({
                                          ...newModelData,
                                          disciplines: [
                                            ...(newModelData?.disciplines?.map(
                                              (d) =>
                                                d.id === discipline.id
                                                  ? { ...d, quantity: value }
                                                  : d,
                                            ) ?? []),
                                            ...(newModelData?.disciplines?.some(
                                              (d) => d.id === discipline.id,
                                            )
                                              ? []
                                              : [
                                                  {
                                                    ...discipline,
                                                    quantity: value,
                                                  },
                                                ]),
                                          ],
                                        });
                                      }}
                                    />
                                    <Button
                                      className="project-config-stepper__btn project-config-stepper__btn--plus"
                                      variant="outline-success"
                                      size="sm"
                                      style={{
                                        minWidth: 28,
                                        padding: 0,
                                        marginLeft: 4,
                                      }}
                                      onClick={() => {
                                        const value = Math.min(
                                          5,
                                          currentValue + 1,
                                        );
                                        setNewModelData({
                                          ...newModelData,
                                          disciplines: [
                                            ...(newModelData?.disciplines?.map(
                                              (d) =>
                                                d.id === discipline.id
                                                  ? { ...d, quantity: value }
                                                  : d,
                                            ) ?? []),
                                            ...(newModelData?.disciplines?.some(
                                              (d) => d.id === discipline.id,
                                            )
                                              ? []
                                              : [
                                                  {
                                                    ...discipline,
                                                    quantity: value,
                                                  },
                                                ]),
                                          ],
                                        });
                                      }}
                                      disabled={currentValue >= 5}
                                      tabIndex={-1}
                                    >
                                      +
                                    </Button>
                                  </div>
                                </td>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </>
                )}
              <ButtonGroup className=" ms-4 me-4">
                <Button
                  id="submit"
                  // type="checkbox"
                  variant="outline-success"
                  onClick={addTaskHandler}
                  disabled={
                    !newModelData?.modelName ||
                    (regionData?.docNumberFormat?.split("-").includes("DC") &&
                      !newModelData?.disciplines) ||
                    (regionData?.docNumberFormat?.split("-").includes("CC") &&
                      !newModelData?.company) ||
                    (regionData?.docNumberFormat?.split("-").includes("LC") &&
                      !newModelData?.location) ||
                    !newModelData?.asset ||
                    (regionData?.docNumberFormat?.split("-").includes("AED1") &&
                      !newModelData?.AED1) ||
                    !newModelData?.mwhAssetName
                  }
                >
                  {isSaving ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span>Add model</span>
                  )}
                </Button>
                {/* </ButtonGroup>
                      <ButtonGroup className=" ms-4 me-4"> */}
                <Button
                  id="closeModal"
                  variant="outline-danger"
                  onClick={onCloseModal}
                >
                  Cancel
                </Button>
              </ButtonGroup>
              <MandatoryExplanation />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* NEW ASSET MODAL */}
      <Modal
        show={assetModal}
        onHide={onCloseAssetModal}
        dialogClassName="model-creation-modal project-config-modal"
        centered
      >
        <Modal.Header className="project-config-modal__header">
          <Modal.Title>New Asset Form</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onCloseAssetModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-config-modal__body">
          {selectedProject[0]?.mviewProjectInfo?.region?.assetFilterReq ? (
            <>
              {assetFilterLevels?.map((level, i) => (
                <Row key={level + i}>
                  <Col>
                    <label className="mt-1">{`What is the ${level}?`}</label>
                    <div>
                      <Select
                        className="basic-single mb-2"
                        options={assetFilters
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .filter((f) => f.level === level)
                          .map((filter) => ({
                            value: filter.code,
                            label: filter.name,
                            data: filter,
                          }))}
                        classNamePrefix="project-config-select"
                        value={
                          newModelData?.assetFilters?.[
                            level
                              .replace(/\s+/g, "")
                              .replace(/^[A-Z]/, (m) => m.toLowerCase())
                          ] || null
                        }
                        onChange={(filter) => {
                          let levelCamelCase = level
                            .replace(/\s+/g, "")
                            .replace(/^[A-Z]/, (m) => m.toLowerCase());
                          const tempAssetFilters = {
                            ...newModelData?.assetFilters,
                            [levelCamelCase]: filter,
                          };

                          let tempObjectInput = {};
                          Object.keys(tempAssetFilters).forEach((key) => {
                            if (
                              tempAssetFilters[key].data.levelIndex <=
                              filter.data.levelIndex
                            ) {
                              tempObjectInput[key] = tempAssetFilters[key];
                            }
                          });
                          setNewModelData({
                            ...newModelData,
                            assetFilters: tempObjectInput,
                            asset: null,
                          });
                          fetchRegionAssetFilters(
                            null,
                            filter.data.id,
                            filter.data.levelIndex,
                            tempObjectInput,
                          );
                        }}
                        isSearchable={true}
                      />
                    </div>
                  </Col>
                </Row>
              ))}
              {/* Check if highest level filterData has been assigned, then render asset select */}
              {(() => {
                if (assetFilterLevels.length > 0) {
                  const highestLevel =
                    assetFilterLevels[assetFilterLevels.length - 1];
                  const highestLevelKey = highestLevel
                    .replace(/\s+/g, "")
                    .replace(/^[A-Z]/, (m) => m.toLowerCase());
                  if (
                    newModelData?.assetFilters &&
                    newModelData.assetFilters[highestLevelKey]
                  ) {
                    return (
                      <div className="row">
                        <div className="col ">
                          <Form.Label className="mt-1">
                            Which asset would you like to add?
                          </Form.Label>
                          <Select
                            className="mb-2"
                            menuPortalTarget={document.body}
                            classNamePrefix="project-config-select"
                            onChange={(e) => {
                              modelInfoChangeHandler(e, "asset");
                            }}
                            options={allAssets?.map((asset) => {
                              return {
                                label: asset.name,
                                value: asset.name,
                                data: asset,
                              };
                            })}
                            value={newModelData?.asset}
                          />
                        </div>
                      </div>
                    );
                  }
                }
                return null;
              })()}
            </>
          ) : (
            <div className="row">
              <div className="col ">
                <Form.Label className="mt-1">
                  Which asset would you like to add?
                </Form.Label>
                <Select
                  className="mb-2"
                  menuPortalTarget={document.body}
                  classNamePrefix="project-config-select"
                  onChange={(e) => {
                    modelInfoChangeHandler(e, "asset");
                  }}
                  options={allAssets?.map((asset) => {
                    return {
                      label: asset.name,
                      value: asset.name,
                      data: asset,
                    };
                  })}
                  value={newModelData?.asset}
                />
              </div>
            </div>
          )}

          <div className="row">
            <div className="col ">
              {regionData &&
                regionData.docNumberFormat &&
                regionData.docNumberFormat.split("-").includes("LC") && (
                  <>
                    <Form.Label className="mt-1">
                      Where on site is the asset located?
                    </Form.Label>
                    <Select
                      className="mb-2"
                      menuPortalTarget={document.body}
                      classNamePrefix="project-config-select"
                      onChange={(e) => {
                        modelInfoChangeHandler(e, "location");
                      }}
                      options={locations?.map((location) => {
                        return {
                          label: location.description,
                          value: location.description,
                          data: location,
                        };
                      })}
                      value={newModelData?.location}
                    />
                  </>
                )}
            </div>
          </div>
          <div className="row">
            <div className="col ">
              {regionData &&
                regionData.docNumberFormat &&
                regionData.docNumberFormat.split("-").includes("CC") && (
                  <>
                    <Form.Label className="mt-1">
                      Which company is responsible for producing the 3D models
                      associated to this asset?
                    </Form.Label>
                    <Select
                      className="mb-2"
                      menuPortalTarget={document.body}
                      classNamePrefix="project-config-select"
                      onChange={(e) => {
                        modelInfoChangeHandler(e, "company");
                      }}
                      options={companyOptions?.map((company) => {
                        return {
                          label: company.name,
                          value: company.name,
                          data: company,
                        };
                      })}
                      value={newModelData?.company}
                    />
                  </>
                )}
            </div>
          </div>

          {/* Asset Extra Data */}
          {selectedProject[0]?.mviewProjectInfo?.region?.assetExtraDataReq &&
            newModelData?.asset && (
              <Row>
                <Col>
                  <Form.Label className="mt-1">
                    {`What is the ${newModelData?.asset?.data?.extraData[0]?.level}?`}
                  </Form.Label>
                  <div>
                    <Select
                      className="mb-2"
                      options={newModelData?.asset?.data.extraData
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((filter) => ({
                          value: filter.code,
                          label: filter.name,
                          data: filter,
                        }))}
                      classNamePrefix="project-config-select"
                      value={newModelData?.AED1 ?? null}
                      onChange={(e) => {
                        modelInfoChangeHandler(e, "AED1");
                      }}
                      isSearchable={true}
                    />
                  </div>
                </Col>
              </Row>
            )}

          {selectedProject[0]?.mviewProjectInfo?.region
            ?.regionAssetExtraDataReq &&
            checkRequired("AED1") &&
            regionalTopLevels.map((level, i) => {
              return (
                <Row key={level + i}>
                  <Col>
                    <Form.Label className="mt-1">{`What is the ${level}?`}</Form.Label>
                    <div>
                      <Select
                        className="mb-2"
                        options={regionData?.assetExtraData
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .filter((filter) => filter.level === level)
                          .map((filter) => ({
                            value: filter.code,
                            label: filter.name,
                            data: filter,
                          }))}
                        classNamePrefix="project-config-select"
                        value={newModelData?.["RAED" + (i + 1)] ?? null}
                        onChange={(e) => {
                          modelInfoChangeHandler(e, "RAED" + (i + 1));
                        }}
                        isSearchable={true}
                      />
                    </div>
                  </Col>
                </Row>
              );
            })}

          <ButtonGroup className=" ms-4 me-4">
            <Button
              id="submit"
              // type="checkbox"
              variant="outline-success"
              onClick={addAssetHandler}
              disabled={
                !newModelData?.asset ||
                (regionData?.docNumberFormat?.split("-").includes("LC") &&
                  !newModelData?.location) ||
                (regionData?.docNumberFormat?.split("-").includes("CC") &&
                  !newModelData?.company) ||
                (regionData?.docNumberFormat?.split("-").includes("AED1") &&
                  !newModelData?.AED1)
              }
            >
              {isSaving ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <span>Add asset</span>
              )}
            </Button>
            {/* </ButtonGroup>
                        <ButtonGroup className=" ms-4 me-4"> */}
            <Button
              id="closeModal"
              variant="outline-danger"
              onClick={onCloseAssetModal}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </Modal.Body>
      </Modal>
      {/* SUBMITTAL MODEL */}
      <Modal
        show={submittalModal}
        onHide={onClosesubmittalModal}
        dialogClassName="model-submittal-modal project-config-modal"
        centered
      >
        <Modal.Header className="project-config-modal__header">
          <Modal.Title>Model Submittal Creation Form</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onClosesubmittalModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-config-modal__body">
          <div className="row">
            <div className="col ">
              <Form.Label className="mt-1">
                Who is the supplier representative?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  submittalInfoChangeHandler(e, "supplierRep");
                }}
                options={allProjectUsers?.map((user) => {
                  return { label: user.email, value: user };
                })}
                value={{
                  value: submittalData?.supplierRep,
                  label: submittalData?.supplierRep?.email,
                }}
              />
              <Form.Label className="mt-1">
                What file type?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  submittalInfoChangeHandler(e, "fileType");
                }}
                options={submittalFileTypes?.map((type) => {
                  return { label: type.name, value: type };
                })}
                value={{
                  value: submittalData?.fileType,
                  label: submittalData?.fileType?.name,
                }}
              />

              <Form.Label className="mt-1">
                Who is responsible for reviewing the model?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  submittalInfoChangeHandler(e, "responsiblePerson");
                }}
                options={allProjectUsers?.map((user) => {
                  return { label: user.email, value: user };
                })}
                value={{
                  value: submittalData?.responsiblePerson,
                  label: submittalData?.responsiblePerson?.email,
                }}
              />
              <Form.Label className="mt-1">Comments</Form.Label>
              <div>
                {/* insert comments component here */}
                {/* insert text area for comments here */}
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={submittalData?.comments}
                  onChange={(e) => {
                    submittalInfoChangeHandler(e, "comment");
                  }}
                />
                {/* <Comments
                            currentUser={userDetails.email}
                            comments={submittalData?.comments}
                            submittalId={submittalData?.id}
                          /> */}
              </div>
              <ButtonGroup className=" ms-4 me-4 mt-1">
                <Button
                  id="submit"
                  // type="checkbox"
                  variant="outline-success"
                  onClick={createSubmittal}
                  disabled={
                    !submittalData?.supplierRep ||
                    !submittalData?.fileType ||
                    !submittalData?.responsiblePerson
                  }
                >
                  {submitting ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span>Request submittal</span>
                  )}
                </Button>
                {/* </ButtonGroup>
                        <ButtonGroup className=" ms-4 me-4"> */}
                <Button
                  id="closeModal"
                  variant="outline-danger"
                  onClick={onClosesubmittalModal}
                >
                  Cancel
                </Button>
              </ButtonGroup>
              <MandatoryExplanation />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* NEW SURVEY MODAL */}
      <Modal
        show={surveyModal}
        onHide={onCloseSurveyModal}
        dialogClassName="model-creation-modal project-config-modal"
        centered
      >
        <Modal.Header className="project-config-modal__header">
          <Modal.Title>Adding A Project Survey</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onCloseSurveyModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-config-modal__body">
          <div className="row">
            <div className="col ">
              <Form.Label>
                Which survey would you like to add?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  surveyModelInfoChangeHandler(e, "survey");
                }}
                options={allSurveys?.map((survey) => {
                  return {
                    label: survey.name,
                    value: survey.name,
                    data: survey,
                  };
                })}
                value={surveyModelData?.survey}
              />
              <Form.Label className="mt-1">
                Which company is responsible for this survey?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                classNamePrefix="project-config-select"
                onChange={(e) => {
                  surveyModelInfoChangeHandler(e, "company");
                }}
                options={companyOptions?.map((company) => {
                  return {
                    label: company.name,
                    value: company.name,
                    data: company,
                  };
                })}
                value={surveyModelData?.company}
              />
              {selectedProject[0]?.mviewProjectInfo?.regionCode === "UU" && (
                <div>
                  <Form.Label className="mt-1">
                    What is the sub-contractor number for this company?
                    <MandatoryFieldIndicator />
                  </Form.Label>
                  <Form.Control
                    className="mb-2 form-control form-control-sm"
                    type="number"
                    min="1"
                    max="99"
                    style={{
                      width: 80,
                      // margin: "0 4px",
                      textAlign: "center",
                    }}
                    value={surveyModelData?.subContractorNumber ?? ""}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      value = Math.max(1, Math.min(99, Number(value) || 1));
                      surveyModelInfoChangeHandler(
                        { target: { value } },
                        "subContractorNumber",
                      );
                    }}
                    placeholder="1-99"
                  />
                </div>
              )}
              <ButtonGroup className=" ms-4 me-4">
                <Button
                  id="submit"
                  // type="checkbox"
                  variant="outline-success"
                  onClick={addSurveyHandler}
                  disabled={
                    !surveyModelData?.survey ||
                    !surveyModelData?.company ||
                    (selectedProject[0]?.mviewProjectInfo?.regionCode ===
                      "UU" &&
                      !surveyModelData?.subContractorNumber)
                  }
                >
                  {isSaving ? (
                    <span>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      {`Survey upload progress: ${surveyProgress} / ${totalTasks}`}
                    </span>
                  ) : (
                    <span>Add survey</span>
                  )}
                </Button>
                <Button
                  id="closeModal"
                  variant="outline-danger"
                  onClick={onCloseSurveyModal}
                >
                  Cancel
                </Button>
              </ButtonGroup>
              <MandatoryExplanation />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={confirmDeleteModalOpen}
        onHide={() => !deleting && setConfirmDeleteModalOpen(false)}
        dialogClassName="project-info-modal app-confirm-modal"
        centered
      >
        <Modal.Header className="project-info-modal__header app-confirm-modal__header">
          <Modal.Title>
            {selectedFiles[0]?.history
              ? "Retire Selected Model(s)?"
              : "Delete Selected Model(s)?"}
          </Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close project-info-modal__close"
              onClick={() => setConfirmDeleteModalOpen(false)}
              aria-label="Close"
              disabled={deleting}
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-info-modal__body app-confirm-modal__body">
          <p className="app-confirm-modal__copy">
            Are you sure you want to {selectedFiles[0]?.history ? "retire" : "delete"} the selected
            {` ${selectedFiles?.length ?? 0} `}
            model(s)?
          </p>
          <div className="app-confirm-modal__actions">
            <button
              type="button"
              className="btn btn-outline-danger project-status-modal__action-btn"
              onClick={() => setConfirmDeleteModalOpen(false)}
              disabled={deleting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-outline-success project-status-modal__action-btn"
              onClick={confirmDeleteModels}
              disabled={deleting}
            >
              {deleting ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                selectedFiles[0]?.history ? "Retire Model(s)" : "Delete Model(s)"
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProjectConfig;
